module.exports = __webpack_public_path__ + "static/img/msdscard.233f40f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msdscard.png
// module id = wZ46
// module chunks = 1